enum EmploymentType {
  EMPLOYMENT_CONTRACT = 'EMPLOYMENT_CONTRACT',
  MANDATE_CONTRACT = 'MANDATE_CONTRACT',
  B2B = 'B2B',
  WORK_CONTRACT = 'WORK_CONTRACT',
}

export default EmploymentType
